import { render } from "./port-fileupload-start-upload-button.vue?vue&type=template&id=7af50ff4"
import script from "./port-fileupload-start-upload-button.vue?vue&type=script&lang=js"
export * from "./port-fileupload-start-upload-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__